// extracted by mini-css-extract-plugin
export default {"input_wrapper":"InputMedia_input_wrapper__rL4hx","image_holder":"InputMedia_image_holder__VzV9B"};